/**
 * Capitalize the first letter of every word.
 * Ex: hello world = Hello World
 */
angular.module('hjApp').filter('capitalize', [
    function () {
        return function (input) {
            return typeof input === 'string'
                ? input.replace(/([^\W_]+[^\s-]*) */g, function (word) {
                      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
                  })
                : '';
        };
    }
]);

/**
 * Capitalize the first letter only.
 * Ex: hello world = Hello world
 */
angular.module('hjApp').filter('capitalizeFirstLetter', [
    function () {
        return function (input) {
            return typeof input === 'string'
                ? input.replace(/^\w/, function (chr) {
                      return chr.toUpperCase();
                  })
                : '';
        };
    }
]);
